var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutBillingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6612 12.6111H34.9286C36.0968 12.6111 37.0439 13.5061 37.0439 14.6102V26.6052C37.0439 27.7093 36.0968 28.6043 34.9286 28.6043H11.6612C10.493 28.6043 9.54599 27.7093 9.54599 26.6052V14.6102C9.54599 13.5061 10.493 12.6111 11.6612 12.6111Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36522 23.6062C5.19702 23.6062 4.25 22.7112 4.25 21.607V9.6121C4.25 8.508 5.19702 7.61294 6.36522 7.61294L29.6327 7.61294C30.8009 7.61294 31.7479 8.50799 31.7479 9.6121",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1031,
    y: 15.5769,
    width: 26.7879,
    height: 2.89599,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.366 23.8259H21.4148",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.1719,
    cy: 23.9619,
    rx: 1.7649,
    ry: 1.69873,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7939,
    height: 20.9913,
    fill: "white",
    transform: "translate(4.25 7.61304)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutBillingIcon);
export default __webpack_public_path__ + "static/media/checkout_billing_icon.8f33ca9cd37f8183df57de4f443fb1ec.svg";
export { ForwardRef as ReactComponent };